import {Component} from 'lowkey-component'


export default class ServiceItems extends Component {
  private observer: IntersectionObserver
  private ratio = 0.1
  private active = -1
  private items: HTMLDivElement[] = []

  constructor(element: HTMLDivElement) {
    super(element)
    this.onScroll = this.onScroll.bind(this)
    this.onIntersection = this.onIntersection.bind(this)

    this.observer = new IntersectionObserver(this.onIntersection, {
      threshold: [0, this.ratio],
    })
  }

  onIntersection(entries: IntersectionObserverEntry[]) {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        window.removeEventListener('scroll', this.onScroll)
        if (entry.isIntersecting) {
          window.addEventListener('scroll', this.onScroll)
        }
      }
    }
  }

  onScroll() {
    const {innerHeight} = window
    const {top = 0, height = 0} = this.element?.getBoundingClientRect() || {}
    const max = height * 1.1
    const pos = innerHeight - top
    const per = pos / max
    const index = this.getItemIndex(per)
    if (
      (index >= 0 || index < this.element?.children.length) &&
      index !== this.active
    ) {
      this.items.map((item, i) => {
        index !== i && item.classList.remove('show')
      })
      this.items[index] && this.items[index].classList.add('show')
      this.active = index
    }
  }

  getItemIndex(per: number) {
    const len = this.element?.children.length || 0
    const chank = 1 / len
    const ret = Math.max(Math.floor(per / chank), 0)
    return ret - 1
  }

  didMount() {
    this.items = [...this.element.querySelectorAll('.m-service-section-item')] as HTMLDivElement[]
    this.observer.observe(this.element)
  }

  didUnmount() {
    this.observer.disconnect()
    window.removeEventListener('scroll', this.onScroll)
  }

}
